import { useEffect, useState } from "preact/hooks";
import { GroundDetectionImg } from "./GroundDetectionImg";
import clsx from "clsx";
import { useRenderer } from "@/hooks/useRenderer";
import { useMount } from "@/hooks/useMount";
import { useArtwork } from "@/hooks/useArtwork";
import { ArtworkState } from "@/context/ArtworkContext";

type TrackingOverlayProps = {
  onStatusNormal: () => void;
};

export const TrackingOverlay = ({ onStatusNormal }: TrackingOverlayProps) => {
  const { trackingStatus, renderer } = useRenderer();
  const [uiStatus, setUiStatus] = useState(trackingStatus ?? "LIMITED");
  const { setArtworkState } = useArtwork();

  useMount(() => {
    setUiStatus(trackingStatus);
    if (trackingStatus === "NORMAL") {
      setUiStatus("NORMAL");
      // setArtworkState(ArtworkState.LOADING);
      onStatusNormal();
      return;
    }
    const timeout = setTimeout(() => {
      if (trackingStatus === "LIMITED") {
        setUiStatus("NORMAL");
        // setArtworkState(ArtworkState.LOADING);
        onStatusNormal();
      }
    }, 3000);

    return () => {
      clearTimeout(timeout);
    };
  });
  useEffect(() => {
    if (!renderer) {
      console.warn("Renderer not found");
      return;
    }
    if (uiStatus === "NORMAL") {
      renderer.showReticle();
    } else {
      renderer.hideReticle();
    }
  }, [uiStatus, renderer]);

  return (
    <>
      <span
        className={clsx(
          "absolute top-[50px] left-4 w-2 h-2 rounded-[50%] animate-fade-in",
          {
            "bg-orange-500": trackingStatus === "LIMITED",
            "bg-green-500": trackingStatus === "NORMAL",
          }
        )}
      ></span>
      {uiStatus === "LIMITED" && (
        <div className="animate-fade-in absolute z-10 w-full h-full bg-[rgba(0,0,0,0.6)] pointer-events-none">
          <div className="w-full relative h-full xz-[999] ">
            <GroundDetectionImg className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" />
          </div>

          {/* <h2 className="p-[30px] w-full font-cba-sans-bold absolute bottom-0 left-0 xmax-w-[350px] text-left text-2xl tracking-[1px] leading-[28px]">
              Move your device to <br /> detect the floor
            </h2> */}
        </div>
      )}
    </>
  );
};
